var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios, { AxiosError } from "axios";
function guid() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    }
    return "".concat(s4()).concat(s4()).concat(s4()).concat(s4()).concat(s4()).concat(s4()).concat(s4());
}
var apiCaller = axios.create({
    baseURL: window.location.origin,
    timeout: 5000,
    headers: {
        "Content-Type": "application/json",
        "x-mts-ssid": localStorage.getItem("JWT"),
        "x-request-id": guid(),
        "x-agent": "mexapp",
        "x-app-version": "1.0.0",
        "x-app-platform": "web",
        "x-device-id": "ios",
        "X-User-Type": "user-profile",
        "X-Currency": localStorage.getItem("currency"),
        "X-Client-ID": "GrabMerchant-Portal",
        "x-grabkit-clientid": "GrabMerchant-Portal",
        requestSource: "troyPortal",
    },
});
export var makeApiCall = function (_a) {
    var url = _a.url, _b = _a.method, method = _b === void 0 ? 'POST' : _b, _c = _a.headers, headers = _c === void 0 ? {} : _c, _d = _a.params, params = _d === void 0 ? {} : _d, _e = _a.body, body = _e === void 0 ? null : _e;
    return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        var _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    _g.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, apiCaller({
                            url: url,
                            method: method,
                            headers: headers,
                            params: params,
                            data: body,
                        })];
                case 1:
                    response = _g.sent();
                    return [2 /*return*/, response.data];
                case 2:
                    error_1 = _g.sent();
                    if (error_1 instanceof AxiosError && error_1.response) {
                        throw new Error(((_f = error_1.response.data) === null || _f === void 0 ? void 0 : _f.message) || error_1.message);
                    }
                    else {
                        throw new Error(String(error_1));
                    }
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
};
//# sourceMappingURL=apiHelper.js.map